import Vue from 'vue';
import axios from 'axios';
import ServiceUtils from '@/services/_ServiceUtilities.js';

var restModel = 'users';
var baseUrl = process.env.apiUrl;
var httpConfig = function() { return {headers: {'x-auth-token': localStorage.getItem('accessToken')}} };

export default {
  getAll(filters, filterMode, limit, sort) {
    return axios.get(baseUrl + '/' + restModel + ServiceUtils.generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },

  getById(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },

  createOne(user) {
    return axios.post(baseUrl + '/' + restModel, user, httpConfig());
  },

  replace(id, fields) {
    return axios.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },

  deleteById(id) {
    return axios.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  }
}



// WEBPACK FOOTER //
// ./src/services/UsersService.js